import axios from "axios";
import i18n from "../il8n/index.js";

var webAPI = axios.create({
  baseURL: process.env.VUE_APP_API_CORE_URL,
});
var crmAPI = axios.create({
  baseURL: process.env.VUE_APP_API_DASHBOARD_URL,
});

// handle request

webAPI.interceptors.request.use((config) => {
  config.headers["Accept-Language"] =  i18n.locale

  return config;
});


export { webAPI, crmAPI };
